import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=25e8fadb&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=ts&"
export * from "./FileView.vue?vue&type=script&lang=ts&"
import style0 from "./FileView.vue?vue&type=style&index=0&id=25e8fadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8fadb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
